import { show } from "../../../../notifications/notifications";
import { NotificationsLevel } from "../../../../lib/enums";

const QUOTA_EXCEEDED = 21500;
const TOO_MANY_RATE_LIMIT_FAILS = 21600;
const TOO_MANY_RATE_LIMIT_WARNING = 21700;

const hasQuotaExceeded = (statusCode: string | number) =>
  statusCode === QUOTA_EXCEEDED;
const isRateLimitError = (statusCode: string | number) =>
  statusCode === TOO_MANY_RATE_LIMIT_FAILS;
const isRateLimitWarning = (statusCode: string | number) =>
  statusCode === TOO_MANY_RATE_LIMIT_WARNING;

const showQuotaExceededNotification = () =>
  show({
    level: NotificationsLevel.INFO,
    html: true,
    sticky: true,
    message: `You have exceeded your ReversingLabs Cloud Sandbox analysis quota. Please contact
                       <a href="mailto:insidesales@reversinglabs.com">ReversingLabs Sales Support</a>
                       for more information.`
  });

const showRateLimitErrorNotification = () =>
  show({
    level: NotificationsLevel.ERROR,
    html: true,
    sticky: true,
    message: `Spectra Intelligence Rate Limit Error - maximum retries exceeded.`
  });

const showRateLimitWarningNotification = () =>
  show({
    level: NotificationsLevel.WARNING,
    html: true,
    sticky: true,
    message: `"Warning: Spectra Intelligence Rate Limiting is in effect. Results may take a while to process."`
  });

const handleRLDynamicAnalysisNotifications = (
  statusCode: string | number
): void => {
  if (hasQuotaExceeded(statusCode)) {
    showQuotaExceededNotification();
  }

  if (isRateLimitError(statusCode)) {
    showRateLimitErrorNotification();
  }

  if (isRateLimitWarning(statusCode)) {
    showRateLimitWarningNotification();
  }
};

export {
  handleRLDynamicAnalysisNotifications,
  showQuotaExceededNotification,
  showRateLimitErrorNotification,
  showRateLimitWarningNotification
};
